import { AppLayout } from "../../components/layout/AppLayout";
import { SearchIndexPanel } from "../../components/suporte/SearchIndexPanel";

export function SearchIndexPage() {
  return (
    <AppLayout>
      <SearchIndexPanel />
    </AppLayout>
  );
}
